import React from 'react'
import PropTypes from 'prop-types'
import {
    Box,
    Text,
    Link as NavLink,
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {Link as RouteLink} from 'react-router-dom'
import Link from '../link'
import CloudinaryImage from '../cloudinary-media/image'
import {useSiteContext} from '../../contexts/site'

const OVERLAY_OPACITY = {
    25: 0.25,
    50: 0.5
}

const NavAssetCard = ({asset, onClickTrack}) => {
    const styles = useMultiStyleConfig('NavAssetCard')
    const {isYR} = useSiteContext()
    const isPortrait = asset.orientation === 'portrait'
    const isOverImage =
        asset.textPosition === 'over-image' || asset.textPosition === 'underline-over-image'
    const overlayOpacity = OVERLAY_OPACITY[asset.fadeOverlayOpacity] || 0
    const hasOverlay = overlayOpacity > 0

    const isExternal = asset.ctaLinkUrl?.includes('.html') || asset.ctaLinkUrl?.startsWith('http')
    const linkProps = isExternal
        ? {to: asset.ctaLinkUrl, isExternal: true, as: NavLink}
        : {to: asset.ctaLinkUrl, as: RouteLink}

    return (
        <Link
            {...linkProps}
            onClick={onClickTrack}
            {...styles.container}
            maxWidth={{
                base: isPortrait ? '234px' : '600px',
                xl: isPortrait ? '300px' : '800px'
            }}
            role="group"
            className="nav-asset-card"
            cursor={asset.ctaText ? 'pointer' : 'default'}
        >
            {hasOverlay && (
                <Box
                    {...styles.overlay}
                    background={`linear-gradient(to bottom, rgba(0, 0, 0, ${overlayOpacity}), rgba(0, 0, 0, 0))`}
                />
            )}

            <CloudinaryImage
                src={asset.imageUrl}
                alt={asset.altText}
                width={isPortrait ? 300 : 800}
                styles={styles.image}
            />

            {asset.ctaText && (
                <Text
                    {...styles.ctaText}
                    position={isOverImage ? 'absolute' : 'static'}
                    bottom={isOverImage ? '15px' : undefined}
                    left={isOverImage ? '15px' : undefined}
                    color={asset.fontColor || '#FFFFFF'}
                    textDecoration={
                        asset.textPosition === 'underline-over-image' ? 'underline' : 'none'
                    }
                    fontFamily={isYR ? 'caslon' : 'cormorant'}
                    textAlign={isOverImage ? 'left' : 'center'}
                    marginTop={!isOverImage ? '9px' : '0'}
                    width={!isOverImage ? '100%' : undefined}
                >
                    {asset.ctaText}
                </Text>
            )}
        </Link>
    )
}

NavAssetCard.propTypes = {
    asset: PropTypes.shape({
        id: PropTypes.string.isRequired,
        orientation: PropTypes.oneOf(['portrait', 'landscape']),
        imageUrl: PropTypes.string.isRequired,
        altText: PropTypes.string,
        ctaText: PropTypes.string,
        ctaLinkUrl: PropTypes.string.isRequired,
        fontColor: PropTypes.string,
        textPosition: PropTypes.oneOf(['over-image', 'underline-over-image', 'below-image']),
        fadeOverlayOpacity: PropTypes.oneOf(['none', '25', '50'])
    }).isRequired,
    onClickTrack: PropTypes.func
}

export default NavAssetCard
